<template>
  <div class="alert-block">
    <!-- Кошельки не совпадают -->
    <div
      v-if="
        accountAddress &&
          arrEth[0]?.value &&
          accountAddress !== arrEth[0]?.value &&
          !ethExists
      "
      class="alert alert-secondary"
      role="alert"
    >
      <div>{{ $t("walletVerification.alert_1") }}</div>
      <div>{{ $t("walletVerification.alert_2") }} {{ arrEth[0]?.value }}</div>
      <div>{{ $t("walletVerification.alert_3") }} {{ accountAddress }}</div>
    </div>

    <!-- Адрес уже существует -->
    <div
      v-if="accountAddress && ethExists"
      class="alert alert-danger"
      role="alert"
    >
      <div>
        {{ $t("walletVerification.alert_4") }} {{ accountAddress }}
        {{ $t("walletVerification.alert_4_2") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Alerts",
  props: {
    accountAddress: {
      type: String,
      default: ""
    },
    arrEth: { type: Array, default: () => [] },
    ethExists: Boolean
  }
};
</script>
